export default __webpack_public_path__ + "static/media/PT.8de16659.svg";